import { ChakraProvider } from "@chakra-ui/react";
import { theme } from "./styles/theme";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastContainer } from "react-toastify";
import "antd/dist/antd.css";
import "react-toastify/dist/ReactToastify.css";
import "./styles/global.scss";
import { RoutesComponent } from "./Routes";
import { formatWhiteLabelNames, getApplicationName } from "./utils";
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
function App() {
  const applicationName = getApplicationName({})

  useEffect(() => {
    const faviconLink = document?.getElementById('favicon');
    faviconLink?.setAttribute('href', `/src/favicon-${applicationName}`);
    //eslint-disable-next-line
  }, []);
  return (
    <ChakraProvider theme={theme}>
      <Helmet>
          <title>{formatWhiteLabelNames(process.env.REACT_APP_APPLICATION_NAME) + " admin"}</title>
          <link id="favicon" rel="icon" />
      </Helmet>
      <BrowserRouter>
        <AuthProvider>
          <ToastContainer />
          <RoutesComponent />
        </AuthProvider>
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default App;
